import styled from 'styled-components';

export const HeroSectionStyles = styled.section`
  position: relative;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);

  .hero-cover {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
  }

  .hero-content {
    position: relative;
    z-index: 1;
    padding: 48px 24px;
    max-width: 720px;
  }

  .hero-logo {
    height: 80px;
    width: auto;
    object-fit: contain;
    margin-bottom: 16px;
    border-radius: 8px;
    background: #fff;
    padding: 8px;
  }

  .hero-title {
    margin: 0 0 12px;
    font-size: 32px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
  }

  .hero-tagline {
    margin: 0;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    min-height: 260px;
    .hero-title {
      font-size: 24px;
    }
    .hero-tagline {
      font-size: 14px;
    }
    .hero-logo {
      height: 56px;
    }
  }
`;

export const SectionStyles = styled.section`
  padding: 48px 24px;
  background: #fff;

  .section-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    margin: 0 0 24px;
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .section-body {
    font-size: 15px;
    line-height: 1.7;
    color: #444;
  }

  .section-body.about-body {
    max-width: 720px;
  }

  .section-loading {
    display: flex;
    justify-content: center;
    padding: 40px;
  }

  &.section-contact {
    background: #f8f9fa;
  }

  &.section-jobs {
    background: #f8f9fa;
  }

  .contact-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 24px;
    max-width: 800px;
  }

  .contact-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .contact-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .contact-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .contact-label {
    font-size: 12px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .contact-value {
    font-size: 15px;
    color: #1a1a1a;
  }

  .contact-value a {
    color: var(--bg-primary, #1890ff);
    text-decoration: none;
  }

  .contact-value a:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    padding: 32px 16px;
    .section-title {
      font-size: 20px;
      margin-bottom: 20px;
    }
  }
`;

export const JobCardStyles = styled.div`
  &.job-card-public {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s, transform 0.2s;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  a:hover &.job-card-public,
  .job-card-link:hover & {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .job-card-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 6px;
    line-height: 1.3;
  }

  .job-card-meta {
    margin-bottom: 6px;
  }

  .job-card-company {
    font-size: 14px;
    color: #666;
  }

  .job-card-address {
    font-size: 13px;
    color: #888;
    margin-bottom: 10px;
  }

  .job-card-salary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #f0f0f0;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
    width: fit-content;
  }

  .salary-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }

  .job-card-time {
    margin-top: auto;
    font-size: 12px;
    color: #888;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .job-card-more {
    color: var(--bg-primary, #1890ff);
    font-weight: 500;
  }
`;
